var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    "data-name": "Group 1542",
    transform: "translate(-868 -295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    transform: "translate(868 295)",
    fill: "#fff",
    stroke: "#a1a7c4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1541",
    "data-name": "Group 1541",
    transform: "translate(876.181 302.837)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 5.913,
    y2: 5.913,
    fill: "none",
    stroke: "#a1a7c4",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 5.913,
    y2: 5.913,
    fill: "none",
    stroke: "#a1a7c4",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButton);
export default __webpack_public_path__ + "static/media/crossButton.e0d8543e0b0037343e6d7715a007e610.svg";
export { ForwardRef as ReactComponent };